import { useEffect } from 'react';
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';

import { CampaignTileView } from '../campaigns/components/CampaignTileView/CampaignTileView.jsx';
import { CampaignEditTileForm } from '../campaigns/components/CampaignEditTileForm.jsx';
import { CampaignNewTileForm } from '../campaigns/components/CampaignNewTileForm.jsx';
import { CampaignEditor } from '../campaigns/components/CampaignEditor.jsx';
import { Preview } from '../campaigns/components/Preview/Preview.jsx';

import { PlanTabsView } from './PlanTabsView.jsx';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const Plan = () => {
  return (
    <HashRouter hashType="noslash">
      <ScrollToTop />
      <Switch>
        {/* Campaign routes */}
        <Route
          path="/campaigns/:campaignId/tile/new"
          render={({ match: { params } }) => (
            <CampaignNewTileForm campaignId={params.campaignId} />
          )}
        />
        <Route
          path="/campaigns/:campaignId/tile/:tileId"
          render={({ match: { params } }) => (
            <CampaignTileView
              tileId={params.tileId}
              campaignId={params.campaignId}
            />
          )}
        />
        <Route
          path="/campaigns/:campaignId/edit/:tileId"
          render={({ match: { params } }) => (
            <CampaignEditTileForm
              tileId={params.tileId}
              campaignId={params.campaignId}
            />
          )}
        />
        <Route
          path="/campaigns/:campaignId/preview"
          render={({ match: { params } }) => <Preview id={params.campaignId} />}
        />
        <Route
          path="/campaigns/:campaignId/edit"
          render={({ match: { params } }) => (
            <CampaignEditor id={params.campaignId} />
          )}
        />
        <Route
          exact
          path="/campaigns/:campaignId"
          render={({ match: { params } }) => (
            <Redirect to={`/campaigns/${params.campaignId}/edit`} />
          )}
        />

        {/* Calendar routes */}
        <Route path="/calendar/:year/:month" component={PlanTabsView} />
        <Route path="/calendar/:year" component={PlanTabsView} />
        <Route path="/calendar" component={PlanTabsView} />

        {/* Default redirect */}
        <Route exact path="/">
          <Redirect to="/calendar" />
        </Route>
      </Switch>
    </HashRouter>
  );
};

export default Plan;
